import { _ as _extends } from '../_rollupPluginBabelHelpers-e8fb2e5c.js';
import React__default, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { c as classnames } from '../index-6ff23041.js';
import { s as styleInject } from '../style-inject.es-746bb8ed.js';

var css_248z = "[data-gene-ui-version=\"2.13.0\"] .divider{background:rgba(var(--background-sc-rgb),.05);height:2.6rem;width:1px}[data-gene-ui-version=\"2.13.0\"] .divider:not(.divider-withNoSpace){margin:0 1.5rem}[data-gene-ui-version=\"2.13.0\"] .divider:not(.divider-withNoSpace).type-horizontal{margin:1.5rem 0}[data-gene-ui-version=\"2.13.0\"] .divider.type-horizontal{height:1px;width:2.6rem}[data-gene-ui-version=\"2.13.0\"] .divider.type-horizontal.full-width{width:100%}";
styleInject(css_248z);

function Divider(_ref) {
  let {
    type,
    className,
    size,
    withSpace,
    ...restProps
  } = _ref;
  const modifiedSize = useMemo(() => typeof size === 'number' ? "".concat(size / 10, "rem") : size, [size]);
  const styles = useMemo(() => type === 'vertical' ? {
    height: modifiedSize
  } : {
    width: modifiedSize
  }, [modifiedSize, type]);
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: classnames('divider', "type-".concat(type), {
      'divider-withNoSpace': !withSpace
    }, className),
    style: styles
  }, restProps));
}
Divider.propTypes = {
  /**
   * Divider direction
   */
  type: PropTypes.oneOf(['horizontal', 'vertical']),
  /**
   * Divider additional className
   */
  className: PropTypes.string,
  /**
   * Divider size will be applied to height(when "type" is set to "vertical") or to width(when "type" is set to "horizontal")
   */
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /**
   * withSpace by default true. If you want to remove the divider`s spacing, switch to false
   */
  withSpace: PropTypes.bool
};
Divider.defaultProps = {
  type: 'vertical',
  withSpace: true
};
Divider.displayName = 'Divider';

export { Divider as default };
